import { render, staticRenderFns } from "./ActiveInfoBlock.vue?vue&type=template&id=4fc88d8c&"
import script from "./ActiveInfoBlock.vue?vue&type=script&lang=ts&"
export * from "./ActiveInfoBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports